export const ACADEMY_EXERCISE_CONTEXT_KEY = 'academy:practical-exercise-context';